import React from "react";
import SearchBar4Table from "../../../../../../components/SearchBar4Table";

const SearchMeetingRoom = ({ onSearch }: any) => {
  return <SearchBar4Table placeholder={"Search by name"} onChange={onSearch} />;
};

export default SearchMeetingRoom;
